import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Table,
  Modal,
  ListGroup,
  InputGroup,
} from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import Select from "react-select";
import {
  postEmployee,
  updatePersonnelReport,
  getPersonList,
  createPerson,
  resetPersonnelReport,
  updatePerson,
  getPersonById,
  updateCurrentPage,
  getPersonZktecoById,
  getAPerson
} from "./ManageEmpSlice";
import SideMenu from "../../UI/SIdeMenu";
import Navibar from "../../UI/Navibar";
import Footer from "../../UI/Footer";
import axios from "axios";
import Pagination from "../../UI/Pagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faEdit, faPlus } from "@fortawesome/free-solid-svg-icons";
import {getDepList} from "../ManageDepartment/ManageDepSlice";

function ManageEmpComponent() {
  const dispatch = useDispatch();
  const [showUpdate, setShowUpdate] = useState(false);
  const [showAdd, setShowAdd] = useState(false); // Add modal state
  const [updateButton, setUpdateButton] = useState(false);
  const [deleteButton, setDeleteButton] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [searchID, setSearchID] = useState('');
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);

  useEffect(() => {
    dispatch(getPersonList()).then((res) => {
      console.log(res);
      console.log(res.payload);

      dispatch(getDepList()).then((res) => {
        if (res.payload) {
          // Map departmentLists to { value, label } format for react-select
          const options = res.payload.map((dept) => ({
            value: dept.departments.id,
            label: dept.departments.description,
          }));
          setDepartmentOptions(options);
        }
      });
    });
  }, []);

  useEffect(() => {
    if (inputValue) {
      dispatch(postEmployee(inputValue));
    }
  }, [inputValue]);

  const { personnels, personnelReport, personsLists, currentPage, personnelReportZk } =
    useSelector((state) => state.ManageEmpSlice);
  const {
    id,
    s_id,
    zkteco_fullname,
    fullname,
    department,
    created,
  } = personnelReport;

  // Filter the list based on search term
  // const filterEmployees = () => {
  //   const lowercasedSearchTerm = searchTerm.toLowerCase();
  //   const filteredList = personsLists.filter(
  //     (person) =>
  //       // person.s_id.toString().includes(lowercasedSearchTerm) ||
  //       // person.s_id.includes(lowercasedSearchTerm) ||
  //       person.fullname.toLowerCase().includes(lowercasedSearchTerm) ||
  //       person.department?.description.toLowerCase().includes(lowercasedSearchTerm)
  //   );
  //   setFilteredEmployees(filteredList);
  // };

  const filterEmployees = () => {
    const lowercasedSearchTerm = searchTerm.toLowerCase();
    const filteredList = personsLists.filter((person) => {
      // Ensure s_id is converted to a string (if it's not already)
      const sIdString = String(person.s_id); // This will handle any type (number, boolean, etc.)
  
      return (
        sIdString.includes(lowercasedSearchTerm) || // Check against s_id
        person.fullname.toLowerCase().includes(lowercasedSearchTerm) ||
        person.department?.description.toLowerCase().includes(lowercasedSearchTerm)
      );
    });
  
    setFilteredEmployees(filteredList);
  };  

  // UseEffect to call the filter function whenever the search term changes
  useEffect(() => {
    filterEmployees();
  }, [searchTerm, personsLists]);

  const handleChangeDropdownPersonnelName = (selectedOption) => {
    console.log(selectedOption);
    const entity = {
      ...personnelReport,
      superior: { id: selectedOption.value },
    };
    dispatch(updatePersonnelReport(entity));
    console.log(entity);
  };

  const handleCloseUpdate = () => {
    const entity = { ...personnelReport };
    dispatch(resetPersonnelReport(entity));
    setSearchID("");
    setShowUpdate(false);
  };

  const handleShowUpdate = () => {
    setShowUpdate(true);
    const entity = { ...personnelReport };
    dispatch(resetPersonnelReport(entity));
  };

  const handleShowAdd = () => {
    setShowAdd(true);
  };

  const handleCloseAdd = () => {
    const entity = { ...personnelReport };
    dispatch(resetPersonnelReport(entity));
    setSearchID("");
    setShowAdd(false);
  };

  const handleChangeForm = (e) => {
    const entity = { ...personnelReport, [e.target.name]: e.target.value };
    console.log(entity);
    dispatch(updatePersonnelReport(entity));
  };
  
  // const handleCreateEmployee = (e) => {
  //   e.preventDefault();
  //   const entity = { ...personnelReport };
  //   console.log(entity);
  //   dispatch(createPerson(entity))
  //     .then(() => {
  //       dispatch(getPersonList()).then(() => {
  //         setShowAdd(false);
  //       });
  //       dispatch(resetPersonnelReport(entity));
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };

  const handleCreateEmployee = (e) => {
    e.preventDefault();
    const entity = { ...personnelReport };
    console.log(entity);
  
    // Create the employee and handle success or failure
    dispatch(createPerson(entity))
      .then(() => {
        // Fetch the updated list and reset the form
        dispatch(getPersonList()).then(() => {
          setShowAdd(false);
          // Show a success alert
          alert('Employee created successfully!');
        })
        .catch((err) => {
          // Handle errors from getPersonList
          console.error('Error fetching person list:', err);
          alert('Failed to add employee. Please try again.');
        });
        dispatch(resetPersonnelReport(entity));
      })
      .catch((err) => {
        // Handle error and show an alert
        console.log(err);
        alert('Failed to create the employee. Please try again.');
      });
  };  

  const handleUpdateButton = (id) => {
    dispatch(getPersonById(id))
      .unwrap() // unwrap the result for direct access to the resolved data
      .then((result) => {
        console.log("Dispatch Result:", result); // Log the result of the dispatch
        setInputValue(result?.superior?.fullname);
        setShowUpdate(true); // Show update modal or perform other actions
      })
      .catch((error) => {
        console.error("Error in dispatch:", error); // Log any errors
      });
  };  

  // const handleUpdateEmployee = (e) => {
  //   e.preventDefault();
  //   const entity = { ...personnelReport };
  //   console.log(entity);
  //   dispatch(updatePerson(entity))
  //     .then(() => {
  //       dispatch(getPersonList()).then(() => {
  //         setShowUpdate(false);
  //         setShowAdd(false);
  //       });
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };

  // const handleDeleteEmployee = (id) => {
  //   const entity = {
  //     ...personnelReport,
  //     id,
  //     status: "-1",
  //   };
  //   console.log(entity);
  //   dispatch(updatePerson(entity))
  //     .then(() => {
  //       dispatch(getPersonList()).then(() => {setShowEmpDetails(false);});
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };

  const handleUpdateEmployee = (e) => {
    e.preventDefault();
  
    // Ask for confirmation before proceeding
    const isConfirmed = window.confirm('Are you sure you want to update this employee?');
    if (!isConfirmed) {
      return; // Exit if the user cancels the update
    }
  
    const entity = { ...personnelReport };
    console.log(entity);
  
    // Proceed with the update operation
    dispatch(updatePerson(entity))
      .then(() => {
        // After successful update, fetch the updated list and close the forms
        dispatch(getPersonList()).then(() => {
          setShowUpdate(false);
          setShowAdd(false);
          // Show a success alert
          alert('Employee updated successfully!');
        })
        .catch((err) => {
          // Handle errors from getPersonList
          console.error('Error fetching person list:', err);
          alert('Failed to fetch updated employee list. Please try again.');
        });
      })
      .catch((err) => {
        // Handle errors by displaying an error alert
        console.log(err);
        alert('Failed to update the employee. Please try again.');
      });
  };  

  const handleDeleteEmployee = (id) => {
    // Ask for confirmation before proceeding
    const isConfirmed = window.confirm('Are you sure you want to delete this employee?');
    if (!isConfirmed) {
      return; // Exit if the user cancels the deletion
    }
  
    const entity = {
      ...personnelReport,
      id,
      status: "-1", // Mark the employee as deleted
    };
  
    // Proceed with the delete operation
    console.log(entity);
    dispatch(updatePerson(entity))
      .then(() => {
        // After successful deletion, fetch the updated list and close the employee details view
        dispatch(getPersonList()).then(() => {
          // Show a success alert
          alert('Employee deleted successfully!');
        })
        .catch((err) => {
          // Handle errors from getPersonList
          console.error('Error delete:', err);
          alert('Failed to delete employee. Please try again.');
        });
      })
      .catch((err) => {
        // Handle errors by displaying an error alert
        console.log(err);
        alert('Failed to delete the employee. Please try again.');
      });
  };  

  function formatName(name) {
    return name.replace(/([a-z])([A-Z])/g, '$1 $2');
  }

  const handleSearchID = () => {
    if (searchID !== "") {
      const id = parseInt(searchID, 10);
      console.log("ID to search:", id);
  
      if (isNaN(id)) {
        console.error("Invalid ID format. Please enter a valid number.");
        return;
      }
  
      // Check if the personnel_id already exists in personsLists
      const personExists = personsLists.some((person) => person.s_id == id);

      if (personExists) {
        console.log(1111)
        // Proceed with dispatch if the ID exists
        dispatch(getAPerson({ id }))
          .unwrap()
          .then((result) => {
              setInputValue(result[0]?.superior?.fullname);
              
              // Construct the entity from getAPerson result
              const entity = {
                  ...personnelReport,
                  id: result[0].id,
                  joined: result[0].joined,
                  superior: {
                      id: result[0].superior?.id,
                      fullname: result[0].superior?.fullname
                  },
              };
  
              // After updating the report, dispatch getPersonZktecoById
              return dispatch(getPersonZktecoById({ id })).unwrap().then((resultZkteco) => {
                  console.log("Dispatch Result for getPersonZktecoById:", resultZkteco); // Log the result after dispatch completes
                  
                  if(resultZkteco.data == null) {
                    setUpdateButton(false);
                    setDeleteButton(true);
                    setInputValue("");
                    const zktecoEntity = {
                      ...entity, // Include the existing entity properties
                      zkteco_fullname: "",
                      fullname: "Staff Resigned",
                      department: {
                        id: "",
                      }
                    };
                    console.log(zktecoEntity)
                    // Dispatch the combined entity
                    dispatch(updatePersonnelReport(zktecoEntity));
                  }
                  else {
                    setUpdateButton(true);
                    setDeleteButton(false);
                    // Merge the data from getPersonZktecoById
                    const zktecoEntity = {
                        ...entity, // Include the existing entity properties
                        s_id: resultZkteco.data.cardNo,
                        zkteco_fullname: resultZkteco.data.name,
                        fullname: formatName(resultZkteco.data.name),
                        department: {
                          id: parseInt(resultZkteco.data.deptCode, 10),
                          description: resultZkteco.data.deptName
                        }
                    };
                    // Dispatch the combined entity
                    dispatch(updatePersonnelReport(zktecoEntity));
                  }
              });
          })
          .catch((err) => {
              console.error("Error in dispatch:", err);
          });
      }     
      else {
        setInputValue("");
        setUpdateButton(false);
        setDeleteButton(false);
        dispatch(getPersonZktecoById({ id }))
        .unwrap()
        .then((result) => {
          console.log("Dispatch Result:", result); // Log the result after dispatch completes
          if(result.data == null) {
            setInputValue("");
            const entity = { ...personnelReport,
              s_id: "",
              zkteco_fullname: "",
              fullname: result.message,
              department: {
                id: "",
                description: ""
              },
              joined: ""
            };
            console.log(entity)
            dispatch(updatePersonnelReport(entity));
          }
          else {
            const entity = { ...personnelReport,
              s_id: result.data.cardNo,
              zkteco_fullname: result.data.name,
              fullname: formatName(result.data.name),
              department: {
                id: parseInt(result.data.deptCode, 10),
                description: (departmentOptions.find((option) => option.value === parseInt(result.data.deptCode, 10))).label
              }
            };
            console.log(entity);
            dispatch(updatePersonnelReport(entity));
          }
        })
        .catch((err) => {
          console.error("Error in dispatch:", err);
        });
      }
    }
  };  

  const pageSize = 20;
  const nPages = Math.ceil(filteredEmployees.length / pageSize);
  const start = (currentPage - 1) * pageSize;
  const end = start + pageSize;
  const currentPageItems = filteredEmployees.slice(start, end);

  const handlePagination = (page) => {
    dispatch(updateCurrentPage(page));
  };

  const handleDepartmentChange = (selectedOption) => {
    const entity = { ...personnelReport, department: { id: selectedOption.value} };
    console.log(entity);
    dispatch(updatePersonnelReport(entity));
  };

  return (
    <div className="Div">
      <Container id="sidebar-wrapper">
        <Row>
          <Col xs={12} className="fixed-top">
            <Navibar />
          </Col>
        </Row>
      </Container>
      <Container fluid>
        <Row>
          <Col
            xs={2}
            id="sidebar-wrapper"
            className="sidemenu"
            style={{ marginTop: "50px" }}
          >
            <SideMenu />
          </Col>
          <Col>
            <Card className="content">
              <Container>
                <Row className="mt-3 mb-3">
                  <Col md={12}>
                    <h4>MANAGE EMPLOYEE</h4>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md={12} style={{ textAlign: "left" }}>
                    EMPLOYEE LIST
                  </Col>
                </Row>

                {/* Search bar */}
                <Row className="mb-3">
                  <Col md={12}>
                    <Form.Control
                      type="text"
                      placeholder="Search by ID, Fullname or Department"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)} // Update search term on input
                    />
                  </Col>
                </Row>

                <Table bordered responsive>
                  <thead>
                    <tr className="tableheader">
                      <th className="text-center">ID</th>
                      <th className="text-center">Employee ID</th>
                      <th className="text-center">FULLNAME</th>
                      <th className="text-center">DEPARTMENT</th>
                      <th className="text-center"></th>
                      <th className="text-center"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentPageItems.map(({ id, s_id, fullname, department }, i) => (
                      <tr key={i}>
                        <td>{id}</td>
                        <td>{s_id}</td>
                        <td>{fullname}</td>
                        <td>{department?.description}</td>
                        <td>
                          <Button variant="primary" onClick={() => handleUpdateButton(id)}>
                            <FontAwesomeIcon icon={faEdit} />
                          </Button>
                        </td>
                        <td>
                          <Button
                            variant="danger"
                            onClick={() => handleDeleteEmployee(id)}
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>

                <Pagination
                  nPages={nPages}
                  currentPage={currentPage}
                  handlePagination={handlePagination}
                />

                <Row className="mb-3">
                  <Modal
                    show={showUpdate}
                    onHide={handleCloseUpdate}
                    backdrop="static"
                    keyboard={false}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>EDIT EMPLOYEE</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Form>
                        <Form.Group>
                          <Form.Label>FULLNAME:</Form.Label>
                          <Form.Control
                            type="text"
                            name="fullname"
                            value={fullname?.toString()}
                            onChange={handleChangeForm}
                          />
                        </Form.Group>
                        <Form.Group>
                          <Form.Label>ZKTECO_FULLNAME:</Form.Label>
                          <Form.Control
                            type="text"
                            name="zkteco_fullname"
                            value={zkteco_fullname?.toString()}
                            onChange={handleChangeForm}
                          />
                        </Form.Group>
                        <Form.Group>
                          <Form.Label>DEPARTMENT:</Form.Label>
                          <Select
                            onChange={handleDepartmentChange}
                            options={departmentOptions} // Use the mapped department options
                            value={departmentOptions.find((option) => option.label === department.description)}
                            placeholder="Select Department"
                          />
                        </Form.Group>
                        {/* <Form.Group>
                          <Form.Label>SUPERVISOR:</Form.Label>
                          <Select
                            type="text"
                            inputValue={inputValue}
                            onInputChange={(value) => setInputValue(value)}
                            onChange={handleChangeDropdownPersonnelName}
                            options={personnels}
                            name="superior"
                          />
                        </Form.Group> */}
                      </Form>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button onClick={handleUpdateEmployee}>UPDATE</Button>
                    </Modal.Footer>
                  </Modal>
                </Row>

                <Row className="mb-3">
                  <Col md={10} />
                  <Col md={2}>
                    <Button variant="primary" 
                    onClick={handleShowAdd}><FontAwesomeIcon icon={faPlus}/> Add</Button>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Modal
                    show={showAdd}
                    onHide={handleCloseAdd}
                    backdrop="static"
                    keyboard={false}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Employee Details</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Form>
                        <Form.Group as={Row} className="align-items-center">
                          <Form.Label column sm={10}>Employee ID:</Form.Label>
                          <Col sm={12} className="d-flex align-items-center">
                            <Form.Control
                              type="text"
                              value={searchID}
                              onChange={(e) => setSearchID(e.target.value)}
                              className="mr-2" // Add right margin for spacing between input and button
                            />
                            &nbsp;&nbsp;
                            <Button onClick={handleSearchID} type="button">SEARCH</Button>
                          </Col>
                        </Form.Group>
                        <Form.Group>
                          <Form.Label>FULLNAME:</Form.Label>
                          <Form.Control
                            type="text"
                            name="fullname"
                            value={fullname}
                            onChange={handleChangeForm}
                          />
                        </Form.Group>
                        <Form.Group>
                          <Form.Label>ZKTECO_FULLNAME:</Form.Label>
                          <Form.Control
                            type="text"
                            name="zkteco_fullname"
                            value={zkteco_fullname}
                            onChange={handleChangeForm}
                          />
                        </Form.Group>
                        <Form.Group>
                          <Form.Label>DEPARTMENT:</Form.Label>
                          <Select
                            onChange={handleDepartmentChange}
                            options={departmentOptions} // Use the mapped department options
                            value={departmentOptions.find((option) => option.label === department.description)}
                            placeholder="Select Department"
                          />
                        </Form.Group>
                        {/* <Form.Group>
                          <Form.Label>SUPERVISOR:</Form.Label>
                          <Select
                            type="text"
                            inputValue={inputValue}
                            onInputChange={(value) => setInputValue(value)}
                            onChange={handleChangeDropdownPersonnelName}
                            options={personnels}
                            name="superior"
                          />
                        </Form.Group> */}
                      </Form>
                    </Modal.Body>
                    <Modal.Footer>
                      {updateButton ? (
                        <Button variant="primary" onClick={handleUpdateEmployee}>Update</Button>
                      ) : (
                        <>
                        {deleteButton ? (
                          <Button variant="danger" onClick={() => handleDeleteEmployee(id)}>Delete</Button>
                        ) : (
                          <Button variant="primary" onClick={handleCreateEmployee}>Add</Button>
                        )}
                        </>
                      )}
                    </Modal.Footer>
                  </Modal>
                </Row>

                {/* {showEmpDetails && (
                  <Card>
                    <Container>
                      <Row className="mb-3 mt-3">
                        <Col md={12}>
                          <h5>Employee Details</h5>
                        </Col>
                      </Row>
                      <Row className="mt-3 mb-3">
                        <Col md={3}>Search Employee ID:</Col>
                        <Col md={7}>
                          <Form.Control 
                            type="text" 
                            value={searchID} 
                            onChange={(e) => setSearchID(e.target.value)} // Capture input value
                          />
                        </Col>
                        <Col md={2}>
                          <Button variant="dark" onClick={handleSearchID}>SEARCH</Button>
                        </Col>
                      </Row>
                      <Row className="mt-3 mb-3">
                        <Col md={12}>
                          <Form>
                            <Form.Group>
                              <Form.Label
                                style={{
                                  textAlign: "left",
                                  width: "100%",
                                  display: "block",
                                }}
                              >
                                FULLNAME:
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="fullname"
                                value={fullname}
                                onChange={handleChangeForm}
                              />
                            </Form.Group>
                            <Form.Group>
                              <Form.Label
                                style={{
                                  textAlign: "left",
                                  width: "100%",
                                  display: "block",
                                }}
                              >
                                ZKTECO_FULLNAME:
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="zkteco_fullname"
                                value={zkteco_fullname}
                                onChange={handleChangeForm}
                              />
                            </Form.Group>
                            <Form.Group>
                              <Form.Label
                                style={{
                                  textAlign: "left",
                                  width: "100%",
                                  display: "block",
                                }}
                              >
                                DEPARTMENT:
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="department"
                                value={department.id}
                                onChange={handleChangeForm}
                              />
                            </Form.Group>
                            <Form.Group>
                              <Form.Label
                                style={{
                                  textAlign: "left",
                                  width: "100%",
                                  display: "block",
                                }}
                              >
                                SUPERVISOR:
                              </Form.Label>
                              <Select
                                type="text"
                                inputValue={inputValue}
                                onInputChange={(value) => setInputValue(value)}
                                onChange={handleChangeDropdownPersonnelName}
                                options={personnels}
                                name="superior"
                                style={{ textAlign: 'center' }}
                              />
                            </Form.Group>
                          </Form>
                        </Col>
                      </Row>
                      <Row className="mt-3 mb-3">
                        <Col md={2}>
                          <Button variant="dark" onClick={() => setShowEmpDetails(false)}>
                            CANCEL
                          </Button>
                        </Col>
                        <Col md={8}></Col>
                        <Col md={2}>
                        {updateButton == true ? (
                          <Button variant="primary" onClick={handleUpdateEmployee}>Update</Button>
                        ) : (
                          <>
                          {deleteButton ? (
                            <Button variant="danger" onClick={() => handleDeleteEmployee(id)}>Delete</Button>
                          ) : (
                            <Button variant="primary" onClick={handleCreateEmployee}>Add</Button>
                          )}
                          </>
                          // <Button variant="primary" onClick={handleCreateEmployee}>Add</Button>
                        )}
                        </Col>
                      </Row>
                    </Container>
                  </Card>
                )} */}
              </Container>
            </Card>
          </Col>
        </Row>
      </Container>
      <Footer />
    </div>
  );
}

export default ManageEmpComponent;
